<template>
    <uw-content title="仓库">
        <template slot="suffix">
            <el-button type="primary" size="mini" icon="el-icon-plus" @click="$refs.warehouseCreate.open()" >新的仓库</el-button>
        </template>
        <uw-table :show-footer="false">
            <template slot="search">
                <el-input @input="$lodash.debounce(TableSearch, 500)" v-model="search.number" clearable  size="mini" placeholder="仓库编码查询"></el-input>
            </template>
            <template slot="data">
                <vxe-table ref="xTable" :data="table" :loading="loading" height="100%">
                    <vxe-column width="90" title="仓库状态" align="center">
                        <template #default="{ row }">
                            <el-tag v-if="row.state == 0" size="mini" effect="dark" type="danger">已停用</el-tag>
                            <el-tag v-if="row.state == 1" size="mini" effect="dark">启用中</el-tag>
                        </template>
                    </vxe-column>
                    <vxe-column min-width="160" title="仓库名称">
                        <template #default="{ row }">
                            <span :class="[ row.state ? 'el-span-primary' : 'el-span-danger' ]" @click="$refs.warehouseDrawer.Open(row.id)"><b>{{ row.name }}</b></span>
                        </template>
                    </vxe-column>
                    <vxe-column min-width="100" field="number" title="仓库编码"></vxe-column>
                    <vxe-column min-width="100" field="address" title="仓库地址"></vxe-column>
                    <vxe-column min-width="100" field="users_admin.name" title="仓库管理员"></vxe-column>
                    <vxe-column min-width="100" field="updated_user.name" title="创建人"></vxe-column>
                    <vxe-column min-width="140" field="updated_at" title="创建时间"></vxe-column>
                    <vxe-column min-width="140" field="created_at" title="更新时间"></vxe-column>
                    <vxe-column min-width="100" fixed="right" align="center">
                        <template #default="{ row }">
                            <el-link :underline="false" type="primary" @click="$refs.warehouseUpdate.Open(row)" :style="{ marginRight: '10px' }">编辑</el-link>
                            <el-link :underline="false" type="danger" @click="TableDelete(row.id)">移除</el-link>
                        </template>
                    </vxe-column>
                </vxe-table>
            </template>
        </uw-table>
        <ims-warehouse-create ref="warehouseCreate" @onChange="TableSearch" />
        <ims-warehouse-update ref="warehouseUpdate" @onChange="TableSearch" />
    </uw-content>
</template>
<script>
export default {
    data () {
        return {
                        loading: false,
            table: [],
                        search: {
                number: null
            },
                        order: {
                method: 'desc',
                column: 'id'
            },
        }
    },
    mounted () {
        this.TableSearch()
    },
    methods: {
                TableSearch() {
                        this.loading = true
            this.$http.post(
                '/9api/ims/warehouse/search-all',
                {
                    search: this.search,
                    order: this.order,
                    append: ['created_user', 'updated_user', 'users_admin']
                }
            ).then(rps => {
                this.table = rps.data
                this.loading = false
            })
        },
                TableDelete(id) {
            this.$http.post('/9api/ims/warehouse/delete', {id: id}).then(rps => {
                this.TableSearch()
            })
        }
    }
}
</script>